var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 2.07692C4.71133 2.07692 3.66666 3.12159 3.66666 4.41026C3.66666 5.69892 4.71133 6.74359 5.99999 6.74359C7.28866 6.74359 8.33333 5.69892 8.33333 4.41026C8.33333 3.12159 7.28866 2.07692 5.99999 2.07692ZM2.58974 4.41026C2.58974 2.52682 4.11656 1 5.99999 1C7.88343 1 9.41025 2.52682 9.41025 4.41026C9.41025 6.29369 7.88343 7.82051 5.99999 7.82051C4.11656 7.82051 2.58974 6.29369 2.58974 4.41026ZM4.5641 10.6923C3.27543 10.6923 2.23076 11.737 2.23076 13.0256V14.4615C2.23076 14.7589 1.98968 15 1.6923 15C1.39492 15 1.15384 14.7589 1.15384 14.4615V13.0256C1.15384 11.1422 2.68066 9.61539 4.5641 9.61539H7.43589C9.31932 9.61539 10.8461 11.1422 10.8461 13.0256V14.4615C10.8461 14.7589 10.6051 15 10.3077 15C10.0103 15 9.76922 14.7589 9.76922 14.4615V13.0256C9.76922 11.737 8.72455 10.6923 7.43589 10.6923H4.5641Z",
    fill: "#5E6C84",
    stroke: "#5E6C84",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.78fcda64d447cd42cce4c263964180d6.svg";
export { ForwardRef as ReactComponent };